import * as React from 'react';
import ReactPaginate from 'react-paginate';
import { SubmissionState } from '../interface/SubmissionInterface';

export default class SubAccordionBody extends React.Component<SubmissionState, SubmissionState> {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0
        };
    }
    renderAccordionBodyByPage = (filteredFileHistory, currentPage) => {
        const start = currentPage * 15;
        const end = (currentPage + 1) * 15;
        filteredFileHistory = filteredFileHistory.sort((a, b) => { return new Date(a.submissionDate) > new Date(b.submissionDate) ? -1 : 1 });
        if (filteredFileHistory.length > 20) {
            filteredFileHistory = filteredFileHistory.slice(start, end);
        }
        return filteredFileHistory.map((record) => {
            return (
                <tr>
                    <td>{record.submissionDate.split(" ")[0]} by {record.adminAccount}</td>
                    <td>{record.fileName}</td>
                </tr>
            );
        });
    };
    handlePageClick = (data) => {
        const currentPage = data.selected;
        this.setState({ currentPage });
    }
    public render() {
        return (
            <table className='table accordion__table'>
                <thead>
                    <tr>
                        <th>Submitted</th>
                        <th>File Name</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderAccordionBodyByPage(this.props.filteredFileHistory, this.state.currentPage)}
                </tbody>
                <div className="pagination">
                <ReactPaginate
                    previousLabel={"<<"}
                    nextLabel={">>"}
                    previousClassName={"previous"}
                    nextClassName={"next"}
                    pageCount={this.props.filteredFileHistory.length < 20 ? 1 : Math.ceil(this.props.filteredFileHistory.length / 15)}
                    pageRangeDisplayed={4}
                    marginPagesDisplayed={3}
                    breakLabel={"..."}
                    breakClassName={"paginate-break"}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"} />
                </div>
            </table>)
    }
}